module.exports = __webpack_public_path__ + "static/media/janssen-sciences.577d7ce4.png";